import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
// Intended to be used with 'summary' and 'details' elements, to close the 'detail' element when clicking outside of it.
// attach this controller to the 'details' element, and set action click@window->close-on-click-outside#closeOnClickOutside

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.element.removeAttribute("open")
    }
  }
}
